export const SIDES = {
  LEFT: 'left',
  RIGHT: 'right',
  WHOLE: 'whole'
};

export const OPPOSITE_SIDE = {
  [SIDES.LEFT]: SIDES.RIGHT,
  [SIDES.RIGHT]: SIDES.LEFT
};
